import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Button, Card, Container, Row, Col, Form, Table, Modal, Tabs, Tab, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { serviceGetCasoImplicado, serviceGetCfgForm } from '../../../../../api/api-antecendentes-legales';
import { serviceGetGestionImplicado, serviceGetComboMonedas, serviceGetPretensionesVigentes } from '../../../../../api/api-cierre-gestion-defenza';
import CoberturaPoliza from './cobertura-poliza';
import DestinatarioPago from './destinatario-pago';
import { Auth, LoadingComponent } from 'recupero-comunes';
import { useFormik } from 'formik';
import { dateFormat, formatoMonto, formato_rut, getBase64, minDate, moneyPunto, resetFormatoMonto, resetFormatoMontoSinPunto, reset_formato_rut } from '../../../../../common/Formatos';
import { validationSchemasPagoGestionDefenza } from '../../../../../common/validation-Shemas-cierre-gestion-defenza';
import { actualizarProvisiones, getParametros } from '../../../../../api/api-gestion-defensa';
import { obtenerProvisionesImplicados } from '../../../../../store/actions/gestion-defensa-action';
import GrillaProvisionesImplicados from './grillaProvisionesImplicados';
import ModalSolicitudAumentoPago from './modalSolicitudAumentoPago';
import { esArchivoGrande, subirArchivoGrandeS3 } from '../../../../../common/uploadArchivoGranTamano';
import { serviceObtieneParametro } from '../../../../../api/api-parametros';
import Mensajes from '../../../../mensajes';

const AddPago = ({ showModal, setShowModal, implicado, fechaIngreso, setPagoSubmit, procesoSelected }) => {
    const fileRef = useRef();
    const dispatch = useDispatch();
    const { codMonedaLocal, codMonedaConsolida } = Auth.currentUser();
    const data_gestion_defensa = useSelector((state) => state.gestionDefensaReducer);
    const { llaves } = data_gestion_defensa;

    const [loading, setLoading] = useState(false);
    const [key, setKey] = useState('destinatario');
    const [cfg_form, setCfg_form] = useState(null);
    const [gestionDefenza, setGestionDefenza] = useState(null);
    const [provisionesVigentes, setProvisionesVigentes] = useState([]);
    const [monedas, setMonedas] = useState(null);
    const [involucrado, setInvolucrado] = useState({});
    const [parametro, setParametro] = useState("");
    const [stateMoneda, setStateMoneda] = useState("");
    const [stateFechaPago, setStateFechaPago] = useState("");
    const [stateComentario, setStateComentario] = useState("");
    const [coberturas, setCoberturas] = useState([]);
    const [stateMontoTotal, setStateMontoTotal] = useState(0);
    const [stateMontTotalAutorizado, setStateMontTotalAutorizado] = useState(0);
    const [archivoContrato, setArchivoContrato] = useState(null);
    const [archivoError, setArchivoError] = useState("");
    const [monedaSelected, setMonedaSelected] = useState("");
    const [responseData, setResponseData] = useState({});
    const [showToast, setShowToast] = useState(false);
    const [showModalInfo, setShowModalInfo] = useState(false);
    const [modalInfo, setModalInfo] = useState("");
    const [dataSubmit, setDataSubmit] = useState({});
    const [showConfirm, setShowConfirm] = useState(false);
    const [titleCoberturas, setTitleCoberturas] = useState("");
    const [showImplicados, setShowImplicados] = useState(false);

    const [showModalProvisionesImplicado, setShowModalProvisionesImplicado] = useState(false);
    const [destinatariosPago, setDestinatariosPago] = useState([]);
    const [showModalSolicitudAumento, setShowModalSolicitudAumento] = useState(false);

    const [limites, setLimites] = useState({ liviano: 8 * 1000000, pesado: 20 * 1000000 });
    const [showConfirmGrande, setShowConfirmGrande] = useState(false);
    const [pendingFile, setPendingFile] = useState(null);
    const archivoSubidoRef = useRef({ file: null, s3Bucket: null, s3Key: null });

    useEffect(() => {
        if (showModal) { setLoading(true); initialData() };
    }, [showModal]);

    useEffect(() => {
        if (gestionDefenza) getProvisionesVigentes();
    }, [gestionDefenza]);

    useEffect(() => {
        //setMonedaSelected(monedas && monedas?.filter(m => Number(m.id) === Number(stateMoneda))[0]?.nombreCorto);
        if (monedas) {
            if (monedas.length === 1) {
                const singleMonedaId = monedas[0].id;
                setStateMoneda(singleMonedaId);
                formik.setFieldValue('codMonedaIngreso', singleMonedaId);
            }
            setMonedaSelected(monedas.filter(m => Number(m.id) === Number(stateMoneda))[0]?.nombreCorto);
        }
    }, [monedas, stateMoneda]);

    useEffect(() => {
        if (coberturas.length) recalculateTotal();
    }, [coberturas]);

    const initialData = async () => {
        setShowImplicados(false);
        await getCfgForm();
        await getGestionDefenza();
        await getCasoImplicado();
        await obtenerParametros();
        await obtenerLimites();
        setLoading(false);
    };

    const obtenerLimites = async () => {
        const [liviano, pesado] = await Promise.all([serviceObtieneParametro(52), serviceObtieneParametro(53)]);
        setLimites({ liviano, pesado });
    };

    const getCfgForm = async () => {
        const query = Buffer.from(JSON.stringify({ rutcia: llaves.idOrgCaso, idform: 48 })).toString('base64');
        const response = await serviceGetCfgForm(query);
        setCfg_form(response);
    };

    const obtenerParametros = async () => {
        const query = Buffer.from(JSON.stringify({ rutcia: 0, parametro: 37 })).toString('base64');
        const response = await getParametros(query);
        setParametro(response.valorParametro);
    };

    const getGestionDefenza = async () => {
        const query_one = Buffer.from(JSON.stringify({ idCaso: llaves.idCaso, idImplicado: implicado })).toString('base64');
        const response_one = await serviceGetGestionImplicado(query_one);

        const paisOrganizacion = Auth.currentUser().paisOrganizacion;
        const codClasCaso = response_one && response_one.length > 0 && response_one[0].codClasCaso;
        const query_two = Buffer.from(JSON.stringify({ pais: paisOrganizacion, clasBien: codClasCaso })).toString('base64');

        const response_two = await serviceGetComboMonedas(query_two);
        setMonedas(response_two);
        setGestionDefenza(response_one[0]);
    };

    const getProvisionesVigentes = async () => {
        let query = Buffer.from(JSON.stringify({
            idCaso: llaves.idCaso,
            idImplicado: implicado,
            tipoGestion: gestionDefenza.codTipoGestion,
            tipoMovimiento: 261004,
            situacion: "245002",
            idProcesoJudicial: procesoSelected.idInstancia
        })).toString('base64');

        let response_one = await serviceGetPretensionesVigentes(query);

        // hasPagoRegistrado: el servicio devolvió coberturas con montoPretencion > 0
        // (pago ya ingresado). En ese caso montoAutoConciliar puede ser 0 en registros 261004.
        const hasPagoRegistrado = validateMonto(response_one.coberturasPoliza);

        if (!hasPagoRegistrado) {
            const query_decoding = JSON.parse(Buffer.from(query, 'base64').toString('utf-8'));
            query_decoding.tipoMovimiento = 261002;
            const query_encoding = Buffer.from(JSON.stringify(query_decoding)).toString('base64');
            response_one = await serviceGetPretensionesVigentes(query_encoding);
            setTitleCoberturas("Reserva");
        } else {
            setTitleCoberturas("Pago");
        }

        if (response_one?.coberturasPoliza) {
            setCoberturas(
                response_one.coberturasPoliza
                    .filter(c => c.actualizaMonto === "S" && (
                        hasPagoRegistrado
                            ? Number(c.montoPretencion) > 0
                            : Number(c.montoAutoConciliar) > 0
                    ))
                    .map(c => ({
                        ...c,
                        montoPretencion: formatoMonto(
                            hasPagoRegistrado ? c.montoPretencion : c.montoAutoConciliar
                        ),
                        montoError: ""
                    }))
            );
        }

        setProvisionesVigentes(response_one);
    };
    function toISODate(dateStr) {
      if (!dateStr) return "";

      const [day, month, year] = dateStr.split("-");
      return `${year}-${month}-${day}`;
    }
    const getCasoImplicado = async () => {
        const query = Buffer.from(JSON.stringify({ idCaso: llaves.idCaso, idImplicado: implicado })).toString('base64');
        const response = await serviceGetCasoImplicado(query);

        const result = (response[0]?.ultimoPagoIndemnizar && response[0]?.ultimoPagoIndemnizar?.CodMonedaIngreso) ? response[0]?.ultimoPagoIndemnizar : response[0]?.ultimaPropuestaIndeminizacion;

        setStateMoneda(response && result?.CodMonedaIngreso ? result?.CodMonedaIngreso : "");
        setStateComentario(response && response[0]?.ultimoPagoIndemnizar?.Comentario ? response[0]?.ultimoPagoIndemnizar?.Comentario : "");
        setStateFechaPago(
          response?.[0]?.ultimoPagoIndemnizar?.FechaActualizacionFormat
            ? toISODate(response[0].ultimoPagoIndemnizar.FechaActualizacionFormat)
            : ""
        );
        setInvolucrado({
            id: response[0]?.IdImplicado,
            rut: response[0]?.RutInvolucrado,
            nombre: response[0]?.NombreInvolucrado,
            tipo: response[0]?.GlosaTipoInvolucrado,
            patente: response[0]?.Patente,
            lesionado: response[0]?.GlosaImplLesionado,
            destinatario: response[0]?.TipoDestinatario || "",
            rutDestinatario: response[0]?.RutDestinatario || "",
            nombreDestinatario: response[0]?.NombreRazonDestinatario || "",
            email: response[0]?.EmailDestinatario || "",
            mdioPago: response[0]?.MedioPago || "",
            institucionFinanciera: response[0]?.InstitucionFinanciera || "",
            tipoCuenta: response[0]?.TipoCuentaFinanciera || "",
            nroCuenta: response[0]?.NroCuentaFinanciera || ""
        });
        setDestinatariosPago(response[0]?.destinatariosPago ? response[0]?.destinatariosPago : [])
    };

    const validateMonto = (data) => {
        return data?.some(value => Number(value.montoPretencion) > 0);
    };

    const handleSelect = (k) => {
        setKey(k === key ? "" : k);
    };

    const handleMontoChange = (index, value) => {
        const nuevas = [...coberturas];
        nuevas[index].montoPretencion = value;
        setCoberturas(nuevas);
    };

    const handleFocusBlur = (action, index, value) => {
        const nuevas = [...coberturas];
        if (action === 'focus') {
            nuevas[index].montoPretencion = resetFormatoMonto(value);
            nuevas[index].montoError = "";
        } else {
            const maxMonto = Number(nuevas[index].montoAutoConciliar);
            const enteredMonto = Number(resetFormatoMonto(value));
            if (maxMonto > 0 && enteredMonto > maxMonto) {
                nuevas[index].montoError = `El monto no puede superar ${formatoMonto(maxMonto)}`;
            } else {
                nuevas[index].montoError = "";
            }
            nuevas[index].montoPretencion = formatoMonto(enteredMonto);
        }
        setCoberturas(nuevas);
        recalculateTotal(nuevas);
    };

    const recalculateTotal = (list = coberturas) => {
        const total = list.reduce(
            (sum, c) => sum + Number(resetFormatoMonto(c.montoPretencion || 0)),
            0
        );
        setStateMontoTotal(formatoMonto(total));

        const totalAutorizado = list.reduce(
            (sum, c) => sum + Number(c.montoAutoConciliar || 0),
            0
        );
        setStateMontTotalAutorizado(formatoMonto(totalAutorizado));
    };

  const formik = useFormik({
    initialValues: {
      codMonedaIngreso: "",
      comentario: "",
      fechaActualizacion: "",
      destinatarioPago: {
        tipoDestinatario: "",
        rut: "",
        dvRut: "",
        nombre: "",
        email: "",
        medioPago: "",
        institucionFinanciera: "",
        tipoCuenta: "",
        numeroCuenta: "",
        montoPago: "",
        parentesco: "",
        fechaNacimiento: ""
      },
      destinatariosPago: []
    },
    validationSchema: validationSchemasPagoGestionDefenza(fechaIngreso),
    onSubmit: async (data) => {
      if (coberturas.some(c => c.montoError)) {
        setShowModalInfo(true);
        setModalInfo("Existen montos que superan el monto autorizado a conciliar. Corrija antes de continuar.");
      } else if (!validateDestinatario(data.destinatarioPago)) {
        setShowModalInfo(true);
        setModalInfo("La información destinatario de pago es opcional, pero si se agrega algún dato se debe completar el formulario.");
      } else if (Number(resetFormatoMonto(stateMontoTotal)) === 0) {
        setShowModalInfo(true);
        setModalInfo("Monto total Propuesta Indemnización debe ser mayor a 0.");
      } else {
        let dataResult = { ...data };
        /*let resetRut = reset_formato_rut(data.destinatarioPago.rut);
        let rut = resetRut.substring(0, resetRut.length - 1);
        let dvRut = resetRut.substring(resetRut.length - 1);*/

        dataResult.idCaso = llaves.idCaso;
        dataResult.idImplicadoCaso = implicado;
        dataResult.idInstanciaProvision = 0;
        dataResult.idOrganizacion = llaves.idOrgCaso;
        dataResult.codMonedaLocal = 30001;
        dataResult.idUsuario = llaves.idUsuario;
        dataResult.tipoMovimiento = 261004;

        dataResult.coberturas = coberturas.map(c => ({
          id: c.id,
          codigoCobertura: c.codigoCobertura,
          codigoAmparoPadre: c.codigoAmparoPadre,
          montoPretension: Number(resetFormatoMonto(c.montoPretencion)),
          montoAutoConciliar: Number(c.montoAutoConciliar) || 0,
          actualizaMonto: c.actualizaMonto || "N"
        }));

        dataResult.fechaActualizacion = data.fechaActualizacion ? data.fechaActualizacion.split('-').join('') : "";
        dataResult.destinatarioPago.rut = data.destinatarioPago.rut;
        dataResult.destinatarioPago.dvRut = '';
        dataResult.idProcesoJudicial = procesoSelected.idInstancia;
        dataResult.destinatariosPago = mapDestinatariosToApi(destinatariosPago);

        if (archivoContrato) {
            if (esArchivoGrande(archivoContrato, limites.liviano)) {
                try {
                    setLoading(true);
                    let archivoRef;
                    if (archivoSubidoRef.current.file === archivoContrato) {
                        archivoRef = archivoSubidoRef.current;
                    } else {
                        archivoRef = await subirArchivoGrandeS3(archivoContrato);
                        archivoSubidoRef.current = { file: archivoContrato, ...archivoRef };
                    }
                    dataResult = { ...dataResult, filename: archivoContrato.name, mimetype: archivoContrato.type, s3Bucket: archivoRef.s3Bucket, s3Key: archivoRef.s3Key };
                    setLoading(false);
                } catch (err) {
                    setLoading(false);
                    setResponseData({ code: -1, object: null, message: err.message });
                    setShowToast(true);
                    return;
                }
            } else {
                const base64data = await getBase64(archivoContrato);
                dataResult = { ...dataResult, filename: archivoContrato.name, mimetype: archivoContrato.type, base64data: base64data.split(',')[1] };
            }
        }

        setDataSubmit(dataResult);

        const sumDestinatarios = destinatariosPago.reduce((sum, d) => sum + Number(d.montoPago?.toString().replace(/\./g, '') || 0), 0);
        const montoTotalRaw = Number(resetFormatoMonto(stateMontoTotal));

        if (destinatariosPago.length > 0 && sumDestinatarios > montoTotalRaw) {
            setShowModalInfo(true);
            setModalInfo('El monto total a pagar es mayor al monto autorizado por la compañía.');
            return;
        }

        if (destinatariosPago.length > 0 && sumDestinatarios < montoTotalRaw) {
            setShowModalInfo(true);
            setModalInfo('La sumatoria de los montos de destinatarios debe ser igual al monto total del cierre.');
            return;
        }

        if (new Date(data.fechaActualizacion) < new Date(minDate(parametro))) setShowConfirm(true);
        else createPago(dataResult);
      }
    }
  });
    const mapDestinatariosToApi = (destinatarios) => {
        return destinatarios.map(dest => ({
        tipoDestinatario: dest.tipoDestinatario,
        rut: dest.rutDestinatario,
        nombre: dest.nombreDestinatario,
        email: dest.emailDestinatario,
        medioPago: dest.medioPago,
        institucionFinanciera: dest.institucion,
        tipoCuenta: dest.tipoCuenta,
        numeroCuenta: dest.numeroCuenta,
        montoPago: dest.montoPago
            ? Number(dest.montoPago.toString().replace(/\./g, ''))
            : 0,
        parentesco: dest.parentesco || "",
        fechaNacimiento: dest.fechaNacimiento || "",
        edad: dest.edad != null ? Number(dest.edad) : null
        }))
    }

    const validateDestinatario = (data) => {
        return (data.tipoDestinatario === "" && data.rut === "" && data.nombre === "" && data.email === "" && data.medioPago === "" && data.institucionFinanciera === "" && data.tipoCuenta === "" && data.numeroCuenta === "")
            || (data.tipoDestinatario && data.rut && data.nombre && data.medioPago && data.institucionFinanciera && data.tipoCuenta && data.numeroCuenta);
    };

    const createPago = async (data) => {
        const dataRequest = showConfirm ? dataSubmit : data;
        setShowConfirm(false);
        setLoading(true);
        const response = await actualizarProvisiones(dataRequest);
        setLoading(false);
        setResponseData(response?.respuestaActProvisiones);
        setShowToast(true);
        if (response?.respuestaActProvisiones?.code !== 1) {
            dataRequest.destinatarioPago.rut = formato_rut(dataRequest.destinatarioPago.rut + dataRequest.destinatarioPago.dvRut);
        }
    };

    const handleCloseToast = () => {
        setShowToast(false);
        if (responseData?.code === 1) { setPagoSubmit(true); handleCloseModal(); }
    };

    const handleCloseModal = () => {
        setShowModal(false);
        formik.resetForm();
        setStateMoneda("");
        setStateFechaPago("");
        setStateComentario("");
        setArchivoContrato(null);
        setArchivoError("");
        if (fileRef.current) fileRef.current.value = "";
        setKey("");
        archivoSubidoRef.current = { file: null, s3Bucket: null, s3Key: null };
    };

    const handleArchivoChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        if (file.size > limites.pesado) {
            setArchivoError(`El archivo no puede superar ${limites.pesado / 1000000}MB.`);
            setArchivoContrato(null);
            e.target.value = "";
            return;
        }
        setArchivoError("");
        if (esArchivoGrande(file, limites.liviano)) {
            setPendingFile(file);
            setShowConfirmGrande(true);
        } else {
            setArchivoContrato(file);
        }
    };

    const handleCancelArchivoGrande = () => {
        setPendingFile(null);
        if (fileRef.current) fileRef.current.value = "";
        setShowConfirmGrande(false);
    };

    const handleConfirmArchivoGrande = () => {
        setArchivoContrato(pendingFile);
        setShowConfirmGrande(false);
    };

    const handleVerProvisionesImplicado = () => {
        if (llaves) {
        setLoading(true);
        //setShowImplicados(true);
        setShowModalProvisionesImplicado(true);
        const query = Buffer.from(JSON.stringify({ idCaso: llaves['idCaso'], tipoMovimiento: 261002 })).toString('base64');
        dispatch(obtenerProvisionesImplicados(query)).then(() => setLoading(false));
        }
    };

  return (
    <Fragment>
      <LoadingComponent show={loading} />
      <Modal show={showModal} onHide={setShowModal} size='xl'>
        <Form onSubmit={formik.handleSubmit}>
          <Card>
            <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>
              {cfg_form && cfg_form["modalpagoindemnizar-title-modal"]} - Caso {llaves.idCaso}
            </Card.Header>

            <Card.Body>
              {/* Datos involucrado */}
              <Container className='mb-4'>
                <Row>
                    <Col md='2'>
                        <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                            {cfg_form && cfg_form["modalpagoindemnizar-lbl-rut"]}
                        </Form.Label>
                        <br />
                        <Form.Text>{involucrado.rut && formato_rut(involucrado.rut)}</Form.Text>
                    </Col>
                    <Col md='3'>
                        <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                            {cfg_form && cfg_form["modalpagoindemnizar-lbl-nombre"]}
                        </Form.Label>
                        <br />
                        <Form.Text className='mb-3'>
                            {involucrado.nombre && involucrado.nombre}
                        </Form.Text>
                    </Col>
                    <Col md='3'>
                        <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                            {cfg_form && cfg_form["modalpagoindemnizar-lbl-tipoinvol"]}
                        </Form.Label>
                        <br />
                        <Form.Text className='mb-3'>
                            {involucrado.tipo && involucrado.tipo}
                        </Form.Text>
                    </Col>
                    <Col md='2'>
                        <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                            {cfg_form && cfg_form["modalpagoindemnizar-lbl-patente"]}
                        </Form.Label>
                        <br />
                        <Form.Text className='mb-3'>
                            {involucrado.patente && involucrado.patente}
                        </Form.Text>
                    </Col>
                    <Col md='2'>
                        <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                            {cfg_form && cfg_form["modalpagoindemnizar-lbl-impllesio"]}
                        </Form.Label>
                        <br />
                        <Form.Text className='mb-3'>
                            {involucrado.lesionado && involucrado.lesionado}
                        </Form.Text>
                    </Col>
                </Row>
              </Container>

              <Container className='mb-4'>
                <Tabs className='nav-tabs' id='uncontrolled-tab-example' activeKey={key} onSelect={handleSelect}>
                  {/*<Tab eventKey="cobertura" title={cfg_form && cfg_form["modalpagoindemnizar-tab-cobert"]}>
                    <CoberturaPoliza cfg_form={cfg_form} codTipoGestion={gestionDefenza?.codTipoGestion} />
                  </Tab>*/}
                  <Tab eventKey="destinatario" title={cfg_form && cfg_form["modalpagoindemnizar-tab-destpago"]}>
                    <DestinatarioPago
                        cfg_form={cfg_form}
                        formik={formik}
                        involucrado={involucrado}
                        destinatariosPago={destinatariosPago}
                        setDestinatariosPago={setDestinatariosPago}
                        montoTotalReserva={stateMontoTotal}
                        fechaSiniestro={gestionDefenza?.fechaSiniestro}
                    />
                  </Tab>
                </Tabs>

                <Row className='form mt-3'>
                  <Col md='3'>
                    <Form.Label className="label is_required">Moneda</Form.Label>
                    <Form.Select
                      name='codMonedaIngreso'
                      onChange={(e) => { formik.handleChange(e); setStateMoneda(e.target.value); }}
                      value={formik.values.codMonedaIngreso = stateMoneda}
                      onBlur={formik.handleBlur}>
                      <option value=''>Seleccione...</option>
                      {monedas?.filter(m => m.id === Number(codMonedaLocal) || m.id === Number(codMonedaConsolida))
                        .map((c) => (<option key={c.id} value={c.id}>{c.nombre}</option>))}
                    </Form.Select>
                    {formik.errors.codMonedaIngreso && formik.touched.codMonedaIngreso &&
                      <Form.Text style={{ color: 'red' }}>{formik.errors.codMonedaIngreso}</Form.Text>}
                  </Col>

                  <Col md='3'>
                    <Form.Label className="label is_required">
                        {cfg_form && cfg_form["modalpagoindemnizar-cmb-fechapago"]}
                    </Form.Label>
                    <br />
                    <Form.Control
                      type="date"
                      name='fechaActualizacion'
                      value={formik.values.fechaActualizacion = stateFechaPago}
                      onChange={e => { formik.handleChange(e); setStateFechaPago(e.target.value); }}
                      onBlur={formik.handleBlur}>
                    </Form.Control>
                    {formik.errors.fechaActualizacion && formik.touched.fechaActualizacion &&
                      <Form.Text style={{ color: 'red' }}>{formik.errors.fechaActualizacion}</Form.Text>}
                  </Col>

                  <Col md='6'>
                    <Form.Label className="label">
                        {cfg_form && cfg_form["modalpagoindemnizar-lbl-docto-transaccion"]}
                    </Form.Label>
                    <br />
                    <Form.Control
                      type="file"
                      accept="application/pdf,image/*,.doc,.docx"
                      ref={fileRef}
                      onChange={handleArchivoChange}
                    />
                    <Form.Text style={{ color: archivoError ? 'red' : '#6c757d' }}>
                        {archivoError || `(Tamaño máximo del archivo: ${limites.pesado / 1000000}MB)`}
                    </Form.Text>
                  </Col>
                </Row>

                <Row className='form mt-3'>
                  <Col md='6'>
                    <Form.Label className="label is_required">
                        {cfg_form && cfg_form["modalpagoindemnizar-input-comentario"]}
                    </Form.Label>
                    <br />
                    <Form.Control
                      name='comentario'
                      value={formik.values.comentario = stateComentario}
                      onChange={e => { formik.handleChange(e); setStateComentario(e.target.value); }}
                      onBlur={formik.handleBlur} />
                    {formik.errors.comentario && formik.touched.comentario &&
                      <Form.Text style={{ color: 'red' }}>{formik.errors.comentario}</Form.Text>}
                  </Col>
                </Row>
              </Container>

              {/* Tabla Coberturas */}
              <Container>
                <div className="container_table">
                  <div className="container_table_header">{titleCoberturas}</div>
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>{cfg_form && cfg_form["modalpagoindemnizar-grilla-cobertura"]}</th>
                        <th>{cfg_form && cfg_form["modalpagoindemnizar-grilla-monto"]} {monedaSelected ? `(${monedaSelected})` : ""}</th>
                        <th>{cfg_form && cfg_form["modalpagoindemnizar-grilla-estado"]}</th>
                        <th>{cfg_form && cfg_form["modalpagoindemnizar-grilla-fecharegistro"]}</th>
                        <th>{cfg_form && cfg_form["modalpagoindemnizar-grilla-mtoindem"]}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {coberturas && coberturas.map((cob, index) => (
                        <tr key={index}>
                          <td>{cob.cobertura}</td>
                          <td>{formatoMonto(cob.montoAutoConciliar)}</td>
                          <td>{cob.glosaEstado}</td>
                          <td>{cob.fechaRegistroFmt}</td>
                          <td>
                            {cob.actualizaMonto === 'S' ? (
                                <>
                                    <Form.Control
                                        name={`monto_${cob.codigoCobertura}`}
                                        readOnly={stateMoneda === "" || cob.actualizaMonto === "N"}
                                        value={cob.montoPretencion}
                                        onChange={(e) => handleMontoChange(index, e.target.value)}
                                        onBlur={(e) => handleFocusBlur('blur', index, e.target.value)}
                                        onFocus={(e) => handleFocusBlur('focus', index, e.target.value)}
                                        onKeyPress={(e) => moneyPunto(e, Number(stateMoneda) !== 30001)}
                                    />
                                    {cob.montoError && <Form.Text style={{ color: 'red' }}>{cob.montoError}</Form.Text>}
                                </>
                            ) : (
                                formatoMonto(cob.montoCobertura, false)
                            )}
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <td><strong>{cfg_form && cfg_form["modalpagoindemnizar-lbl-total"]}</strong></td>
                        <td><strong>{stateMontTotalAutorizado} {monedaSelected ? `(${monedaSelected})` : ""}</strong></td>
                        <td colSpan={2}></td>
                        <td><strong>{stateMontoTotal} {monedaSelected ? `(${monedaSelected})` : ""}</strong></td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </Container>
            </Card.Body>
            <Card.Footer>
                {showToast && 
                    <Mensajes
                        showToast={showToast}
                        handleCloseToast={handleCloseToast}
                        delay={5000}
                        responseData={responseData}
                    ></Mensajes>
                }                        
                <Container>
                    <Row>
                        <Col className='d-flex align-items-end justify-content-end m-2 p-0'>
                            <Button className='m-2 w-auto' variant='outline-info' onClick={handleCloseModal}>
                                {cfg_form && cfg_form["modalpagoindemnizar-btn-volver"]}
                            </Button>
                            {/*<Button className='m-2 w-auto' variant='verGrilla' onClick={handleVerProvisionesImplicado}>
                                {cfg_form ? cfg_form['modalpagoindemnizar-btn-implicados'] : ''}
                            </Button>*/}
                            <Button type="submit" className='m-2 w-auto' variant='danger' disabled={loading}>
                                {loading && <Spinner as="span" animation="border" size="sm" className="me-2" />}
                                {cfg_form && cfg_form["modalpagoindemnizar-btn-actualizar"]}
                            </Button>
                            <Button className='m-2 w-auto' variant='success' onClick={() => setShowModalSolicitudAumento(true)}>
                                {cfg_form ? cfg_form['modalpagoindemnizar-btn-solaumto'] : 'Solicitar Aumento Pago'}
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </Card.Footer>
          </Card>
          {showModalProvisionesImplicado &&
              <GrillaProvisionesImplicados
                  setShowModalProvisionesImplicado={setShowModalProvisionesImplicado}
                  showModalProvisionesImplicado={showModalProvisionesImplicado}
              />
          }
          {showModalSolicitudAumento &&
              <ModalSolicitudAumentoPago
                  show={showModalSolicitudAumento}
                  onHide={() => setShowModalSolicitudAumento(false)}
                  implicado={implicado}
                  involucrado={involucrado}
                  coberturas={coberturas}
              />
          }
        </Form>
      </Modal>

      <Modal show={showModalInfo} onHide={() => setShowModalInfo(false)}>
        <Card>
            <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#e8761a', color: 'white' }}>
                Información
            </Card.Header>
            <Card.Body>{modalInfo}</Card.Body>
            <Card.Footer style={{ display: 'flex', justifyContent: 'center' }}>
                <Button className='m-2 w-auto' variant='outline-info' onClick={() => setShowModalInfo(false)}>Cerrar</Button>
            </Card.Footer>
        </Card>
      </Modal>
      {/* Confirmación */}
        <Modal show={showConfirm} onHide={() => setShowConfirm(false)}>
            <Card>
                <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#e8761a', color: 'white' }}>
                    Confirmación
                </Card.Header>
                <Card.Body>
                    Fecha de pago comprometida es menor al plazo fijado para emitir pago, desea continuar?
                </Card.Body>
                <Card.Footer style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button className='m-2 w-auto' variant='danger' onClick={() => createPago(dataSubmit)}>SI</Button>
                    <Button className='m-2 w-auto' variant='outline-info' onClick={() => setShowConfirm(false)}>NO</Button>                    
                </Card.Footer>
            </Card>
        </Modal>
        <Modal show={showConfirmGrande} onHide={handleCancelArchivoGrande}>
            <Card>
                <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#e8761a', color: 'white' }}>
                    Confirmación
                </Card.Header>
                <Card.Body>
                    {`El archivo seleccionado supera los ${limites.liviano / 1000000}MB, por lo que la carga puede demorar más de lo habitual. ¿Desea continuar?`}
                </Card.Body>
                <Card.Footer style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button className='m-2 w-auto' variant='outline-info' onClick={handleCancelArchivoGrande}>No</Button>
                    <Button className='m-2 w-auto' variant='danger' onClick={handleConfirmArchivoGrande}>Sí</Button>
                </Card.Footer>
            </Card>
        </Modal>
        <style type='text/css'>
            {`
                .container_table_header {
                    padding: 10px 20px;
                    background-color: #716e9e;
                    border-top-left-radius: 5px;
                    border-top-right-radius: 5px;
                    color: white
                }
                .customCard {
                    padding-top: 0;
                    padding-left: 0;
                    padding-right: 0;
                }
                .customHeaderCard {
                    background-color: rgb(176 175 196);
                    color: #3a3a8d;
                    font-size: 17px;
                    font-weight: 600
                }
                .customTable > thead {
                    color: white; 
                    background-color: rgb(114, 139, 176);
                }
                .customTable > thead > tr > th {
                    padding: 20px 0;
                }
                .label {
                    font-weight: bold;
                    font-size: 14px;
                }
                .is_required:after {
                    content: "*";
                    margin-left: 2px;
                    color: #000;
                    font-weight: 500;
                    font-size: 12pt;
                }
                .btn-verGrilla {
                    background-color: #55B2CE;
                    color: #FFFFFF;
                    width: 168px;
                    }
                .btn-verGrilla:hover{
                        background-color: #87c9dc;
                        color: #FFFFFF;
                }
            `}
        </style>
    </Fragment>
  );
};

export default AddPago;